/**
 * Choosing a client in one field (owner report, 2026-10-02): the Combobox,
 * listing every client someone could choose, by name and company type.
 */
import type { ClientChoice } from "../../api/types";
import { Combobox } from "./Combobox";

function clientLabel(client: ClientChoice): string {
  return client.company_type_label === "Customer" ? client.name : `${client.name} (${client.company_type_label})`;
}

export function ClientCombobox({
  label,
  choices,
  failed = false,
  value,
  onChange,
}: {
  label: string;
  // Undefined while they load.
  choices: ClientChoice[] | undefined;
  failed?: boolean;
  // The chosen client's ID, or "".
  value: string;
  onChange: (clientId: string) => void;
}) {
  return (
    <Combobox
      label={label}
      options={(choices ?? []).map((client) => ({ value: client.id, label: clientLabel(client) }))}
      value={value}
      onChange={onChange}
      loading={choices === undefined && !failed}
      failed={failed}
      placeholder="Choose a client"
      loadingText="Loading clients…"
      failedText="Couldn't load clients"
    />
  );
}
